module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres4ax-popup1",
      "id": "hres4ax-popup1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup1"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "button-popup1",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popup1.detail.codcompy) + " - " + _vm._s(_vm.popup1.detail.desc_codcompy) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popup1.detail.codlinef) + " - " + _vm._s(_vm.popup1.detail.desc_codlinef) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.popup1.detail.dteeffec)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popup1.detail.desc_codcomp))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES4AXC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.popup1.detail.desc_codpos))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('popup1-tab1', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup1.tab1,
      "popup1Tab1Table": _vm.popup1Tab1Table
    }
  }), _vm._v(" "), _c('popup1-tab2', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup1.tab2,
      "popup1Tab2Table": _vm.popup1Tab2Table
    }
  }), _vm._v(" "), _c('popup1-tab3', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup1.tab3,
      "popup1Tab3Table": _vm.popup1Tab3Table
    }
  }), _vm._v(" "), _c('popup2', {
    attrs: {
      "labels": _vm.labels,
      "detail": _vm.detail,
      "popup2": _vm.popup2,
      "popup2Tab2Table": _vm.popup2Tab2Table,
      "popup2Tab3Table": _vm.popup2Tab3Table
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd503c50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres4ax/popup1.vue
// module id = 3979
// module chunks = 1